import { FormControlLabel, Link, Radio, RadioGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import DatePicker from "../../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddNominee: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [fullName, setFullName] = React.useState("");
  const [relationEmployee, setRelationEmployee] = React.useState("");
  const [age, setAge] = React.useState("");
  const [nomineeDob, setNomineeDob] = React.useState<Date | null>(new Date());

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const relationEmployee_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-3 text-left">Fill Nominee Details</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-2">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
          <Grid xs={12} className="mb-4">
            <hr />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ paddingTop: "0" }}
        >
          <Grid xs={12}>
            <div className="scrollable_area">
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Full Name"
                    value={fullName}
                    attrName={setFullName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Relationship with employee"
                    value={relationEmployee}
                    attrName={setRelationEmployee}
                    value_update={updateMasterState}
                    dropdown_data={relationEmployee_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <DatePicker
                    class_name="inputField"
                    title="Date of Birth"
                    value={nomineeDob}
                    attrName={setNomineeDob}
                    value_update={updateMasterState}
                    error_message="Please enter Date of Birth"
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Age"
                    value={age}
                    attrName={setAge}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid xs={12} className="footer_sec">
            <Link
              className="save_btn"
              onClick={() => {
                value_update(attrName, false);
              }}
            >
              Submit
            </Link>
          </Grid>
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default AddNominee;
